<template>
  <div class="i-report-navbar-mobile">
    <div class="wrap">
      <iOnboardingTooltip
        :value="1"
        show-bottom-tip
      />
      <template
        v-for="item in coreItems.filter((e) => !e.isHidden)"
        :key="item.text"
      >
        <iNavbarItemMobile :item="item" />
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
// Components
import iNavbarItemMobile from "@/components/report/navbar/NavbarItemMobile.vue"
import iOnboardingTooltip from "@/components/report/OnboardingTooltip.vue"

// Types
import type { NavigationItem } from "@/types/navigationItem"
import type { PropType } from "vue"

// Props
defineProps({
  coreItems: {
    type: Array as PropType<NavigationItem[]>,
    default: () => []
  },
  profileItems: {
    type: Array as PropType<NavigationItem[]>,
    default: () => []
  },
  supportItems: {
    type: Array as PropType<NavigationItem[]>,
    default: () => []
  }
})
</script>

<style lang="scss" scoped>
.i-report-navbar-mobile {
  z-index: $z-index-navbar;
  width: 100%;
  border-top: 1px solid $pickle-bluewood100;
  bottom: 0;
  position: fixed;
  background-color: $white !important;
  padding-top: 14px;
  height: 82px;

  @include flex($direction: row, $justify: center, $align: flex-start);

  .wrap {
    max-width: 480px;
    width: 100%;
    padding: 0 24px;

    @include flex($direction: row, $justify: space-between, $align: center, $gap: 8px);
  }
}

@media print {
  .i-report-navbar-mobile {
    display: none;
  }
}
</style>
